var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sb-left-menu" }, [
    _c(
      "div",
      { attrs: { id: "menuIcon" } },
      [
        _c(
          "v-toolbar-side-icon",
          {
            class: [_vm.drawer ? "sb-sidebar-open" : "", "main-hamburger-menu"],
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              }
            }
          },
          [
            _c("span", { staticClass: "line-1" }),
            _c("span", { staticClass: "line-2" }),
            _c("span", { staticClass: "line-3" })
          ]
        ),
        _vm._v(" "),
        _c("v-divider")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { on: { mouseover: _vm.openDrawer, mouseleave: _vm.closeDrawer } },
      [
        _c(
          "v-navigation-drawer",
          {
            class:
              "sb-nav-drawer " +
              (_vm.mountedInOldLayout ? "old-layout" : undefined),
            attrs: {
              "mini-variant": _vm.closed,
              "mini-variant-width": _vm.width,
              floating: "",
              touchless: "",
              "expand-on-hover": "",
              app: "",
              clipped: "",
              permanent: ""
            },
            on: {
              "update:miniVariant": function($event) {
                _vm.closed = $event
              },
              "update:mini-variant": function($event) {
                _vm.closed = $event
              }
            }
          },
          [
            _c(
              "vuescroll",
              { ref: "vs", attrs: { ops: _vm.ops } },
              [
                _c(
                  "v-list",
                  { attrs: { dense: "" } },
                  _vm._l(_vm.navBarGroups, function(group, idx) {
                    return _c(
                      "div",
                      { key: "nav-bar-group-" + idx },
                      _vm._l(group, function(item, jdx) {
                        return _c(
                          "v-list-tile",
                          {
                            key: "nav-bar-item-" + idx + "-" + jdx,
                            class: item.id ? "pointer" : "",
                            attrs: {
                              id: item.id || item.title,
                              href: item.useRouter ? undefined : item.link,
                              to: item.useRouter ? item.link : undefined,
                              value: _vm.highlightActiveLink(item)
                            }
                          },
                          [
                            !item.link && item.subModules
                              ? [
                                  _c(
                                    "v-list-group",
                                    {
                                      attrs: { "no-action": "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-list-tile-action",
                                                  {
                                                    attrs: { title: item.title }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "material-icons-outlined"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              item.iconText
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c("v-list-tile-title", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(item.title) +
                                                          "\n                      "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.active,
                                        callback: function($$v) {
                                          _vm.$set(item, "active", $$v)
                                        },
                                        expression: "item.active"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm._l(item.subModules, function(
                                        subLink,
                                        i
                                      ) {
                                        return _c(
                                          "v-list-tile",
                                          {
                                            key: i,
                                            attrs: {
                                              href: subLink.href,
                                              value: _vm.highlightActiveLink(
                                                subLink
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-title",
                                              [
                                                subLink.iconText
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "material-icons-outlined vertical-middle"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              subLink.iconText
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(subLink.text) +
                                                    "\n                    "
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              : [
                                  _c(
                                    "v-list-tile-action",
                                    { attrs: { title: item.title } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "material-icons-outlined"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.iconText) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.title) +
                                            "\n                  "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                          ],
                          2
                        )
                      }),
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }